import React from 'react'
import Form from './Form'
import { Breadcrumb, SimpleCard } from 'app/components'
import { Box, styled } from '@mui/system'

const Container = styled('div')(({ theme }) => ({
    margin: '30px',
    [theme.breakpoints.down('sm')]: {
        margin: '16px',
    },
    '& .breadcrumb': {
        marginBottom: '30px',
        [theme.breakpoints.down('sm')]: {
            marginBottom: '16px',
        },
    },
}))

const AddQuestion = () => {
    return (
        <Container>
            <div className="breadcrumb">
                <Breadcrumb
                    routeSegments={[
                        { name: 'Questions', path: '/admin/questions/all' },
                        { name: 'Form' },
                    ]}
                />
            </div>
            <SimpleCard title="Add Question">
                <Form />
            </SimpleCard>
            <Box py="12px" />
        </Container>
    )
}

export default AddQuestion
